import urlFilter from "../filters/url.filter"

/**  Данные манифеста API. */
export class CreditProductData {

  // Идентификатор вида кредита.
  public TypeID: string = '';

  // Вид продукта.
  public TypeProduct: string = '';

  // Название кредита.
  public TypeName: string = '';

  // Валюта кредита.
  public TypeCurName: string = '';

  // Процентная ставка.
  public TypeRate: number = 0;

  public TypeMinRate: number = 0;

  // Обеспечение.
  public TypeEnsure: boolean = false;

  // Страхование.
  public TypeInsurance: boolean = false;

  // Зачисления ЗП.
  public TypeSalary: string = '';

  // График погашения.
  public TypePlanPay: string = '';

  // Минимальный срок, мес.
  public TypeMinTerm: number = 0;

  // Максимальный срок, мес.
  public TypeMaxTerm: number = 0;

  // Минимальная сумма.
  public TypeMinSum: number = 0;

  // Максимальная сумма.
  public TypeMaxSum: number = 0;

  // Комментарий.
  public TypeComment: string = '';

  // Id операции.
  public OperId: string = '';

  //  Ключ к настройке в appSettings в Web.config приложения на IIS
  //  по ключу лежит Id операции заявка на кредит в каталоге на бизнес логике.
  public OperKey: string = '';

  // Вид кредита.
  public TypeProductName: string = '';  

  public TypeSubProduct: number = 0;

  public TypeSubProductName: string = '';

  public TypeVIP: boolean = false;

  public ProductImageName: string = '';

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      this.TypeID = src.TypeID ?? '';
      this.OperKey = src.operKey ?? '';
      this.OperId = src.operId ?? '';
      this.TypeProduct = src.TypeProduct ?? '';
      this.TypeName = src.TypeName ?? '';
      this.TypeCurName = src.TypeCurName ?? '';
      this.TypeRate = src.TypeRate ?? 0;
      this.TypeMinRate = src.TypeMinRate ?? 0;
      this.TypeEnsure = src.TypeEnsure === 'true';
      this.TypeInsurance = src.TypeInsurance === 'true';
      this.TypeSalary = src.TypeSalary ?? '';
      this.TypePlanPay = src.TypePlanPay ?? '';
      this.TypeMaxTerm = src.TypeMaxTerm ?? 0;
      this.TypeMinTerm = src.TypeMinTerm ?? 0;
      this.TypeMinSum = parseInt(src.TypeMinSum) ?? 0;
      this.TypeMaxSum = parseInt(src.TypeMaxSum) ?? 0;
      this.TypeComment = src.TypeComment ?? '';
      this.TypeProductName = src.TypeProductName ?? '';
      this.TypeSubProduct = src.TypeSubProduct ?? 0;
      this.TypeSubProductName = src.TypeSubProductName ?? '';
      this.TypeVIP = src.TypeVIP === 'True';
      this.ProductImageName = urlFilter(src.ProductImageName) ?? '';
    }
  }
}
